
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import * as React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { isLocaleGerman } from '@/lib/data-transformer/gindumacUtils';
import LegalLayout from '@/components/layout/LegalLayout';
import { gtagContactEvent } from '@/lib/utilities/analytics/gtm';

export default function LogisticsServicesPage() {
  const { locale } = useRouter();
  return (
    <LegalLayout>
      {!isLocaleGerman(locale) ? (
        <>
          <h1 className='subtitle-legal'>Privacy statement of GINDUMAC GmbH</h1>
          <br />
          <span className='date'>Updated 02.07.2018</span>

          <p>
            GINDUMAC GmbH (hereinafter referred to as <strong>{`"GM"`}</strong>)
            takes the concerns of data protection seriously and would like to
            ensure that the privacy of the users of its websites as well as of
            its customers is protected. The user respectively the customer
            should be informed about the use and the handling of his data with
            the following information relating to data processing.
          </p>
          <p>
            <strong>GM</strong> reserves the right to adjust the contents of the
            privacy statement from time to time. It therefore recommends the
            users respectively its customers to read the following information
            relating to data processing once again at regular intervals.
          </p>
          <ol className='ml-4 list-decimal space-y-4'>
            <li>
              <h2>Personal data</h2>
            </li>
            <p>
              (1) <strong>GM</strong> shall only collect, process and use the
              personal data of the users of its website or its customers with
              their consent or if this is permitted by a legal regulation.{' '}
              <strong>GM</strong> will only collect, process and use such
              personal data, which are necessary for the execution and the use
              of its services or which the customer or user of the website
              voluntarily makes available to it.
            </p>
            <p>
              (2) Deemed as personal are all data, which include details of
              personal or factual relationships of a certain or definable user
              or customer. This shall, for example, include the name, the e-mail
              address, the residential address, the gender, the date of birth,
              the telephone number or also the age of a natural person.
            </p>

            <li>
              <h2>Purposes for the collection of personal data</h2>
            </li>
            <p>
              <strong>GM</strong> requires the personal data of the customer or
              user of the website for the following purposes:
            </p>
            <ul>
              <li>
                - For processing the placed order or the purchase order (e-mail
                address, delivery address),
              </li>
              <li>
                - For answering questions (e-mail address and telephone number),
              </li>
              <li>
                - with the registration for the newsletter the e-mail address is
                used for own advertising purpose, until the user or customer
                cancels his subscription for the newsletter. The cancellation is
                possible at all times under{' '}
                <a
                  onClick={gtagContactEvent}
                  href='mailto:contact@gindumac.com'
                  className='link'
                >
                  contact@gindumac.com
                </a>
                .
              </li>
            </ul>

            <li>
              <h2>Automatic data entry by cookies</h2>
            </li>
            <p>
              A cookie is a small text file, which is stored in the interim
              storage of the browser of the user or customer and which enables
              an analysis of the use of the <strong>GM</strong> website by the
              user or customer. The following data will be entered automatically
              by the <strong>GM</strong> computer system through cookies when
              the websites are called:
            </p>
            <ul>
              <li>- The Internet address (IP address) of the user/customer,</li>
              <li>- Browser type and version,</li>
              <li>
                - Website, from which the user/customer visits the website of
                GINDUMAC GmbH (Referrer URL)
              </li>
              <li>- Used operating system,</li>
              <li>
                - Website from which the user/customer is forwarded to other
                websites,
              </li>
              <li>- Date and time of the access.</li>
            </ul>
            <p>
              These data are stored separately from the other data of the user
              or customers, who voluntarily provide these to <strong>GM</strong>
              . These data are not linked with the voluntarily submitted data of
              the user or customer. These data are merely evaluated for
              statistical purposes in order to be able to optimise the{' '}
              <strong>GM</strong> websites and their offers. The data will be
              deleted after their evaluation.
            </p>
            <p>
              Should the user or customer not request the use of the cookies he
              can block the use in his browser. In this case it cannot be
              excluded that the functionality of the <strong>GM</strong> website
              is impaired hereby.
            </p>
            <p>
              See more details in our{' '}
              <Link href={`/cookies`}>cookie policy</Link>.
            </p>

            <li>
              <h2>
                Collection and processing of data with the use of
                Google-Analytics
              </h2>
            </li>
            <p>
              This website uses Google-Analytics, a web analysis service of
              Google Inc. (hereinafter referred to as{' '}
              {`"Google").
              Google-Analytics uses so-called "cookies"`}
              . These are text files, which are stored on the computer of the
              user or customer and which enable the analysis of the use of the
              website by the user or customer.
            </p>
            <p>
              The information generated by the cookie regarding the use of the
              website is anonymised so that it can no longer be allocated to a
              connection. These anonymised data are assigned to a server of
              Google in the USA and stored there. In the event that the IP
              anonymization is activated on this website the IP address of the
              user or customer will, however, be previously abbreviated by
              Google within the member states of the EU or other contracting
              states of the Treaty on the European Economic Area. Only in
              exceptional cases will the full IP address be assigned to a server
              in the USA and abbreviated there. By order of the operator of this
              website Google will use this information in order to evaluate the
              use of the website by the user or customer in order to compile
              reports regarding the website activities for the website operators
              and in order to provide further services associated with the
              website use and the Internet use.
            </p>
            <p>
              Google will in no way connect the IP address of the user or
              customer with other data of Google. The user or customer can
              prevent the installation of the cookies by a corresponding setting
              of the browser software. <strong>GM</strong> will point out to the
              user or customer that in this case, if applicable, it will no
              longer be possible to use all functions of the visited website in
              full.
            </p>
            <p>
              The user or customer can in addition prevent the entry of the data
              generated by the cookie and which refers to the use of the
              website, including the IP address, to Google as well as the
              processing of these data by Google by the fact that he downloads a
              browser Add-on for the deactivation of Google Analytics and
              installs it for his browser. The deactivation Add-On can be called
              via{' '}
              <a
                href='http://tools.google.com/dlpage/gaoptout?hl=de'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                http://tools.google.com/dlpage/gaoptout?hl=de
              </a>
              .
            </p>
            <p>
              <strong>GM</strong> also uses the Google AdWords remarketing
              services to advertise on third party websites to previous visitors
              to our website. With the use of re-marketing tracking cookies,
              Google will show ads across web sites that customers are visiting.
              The ads are shown across web sites and are based on the past
              visits to <strong>GM</strong> website by using cookies.
            </p>
            <p>
              <strong>GM</strong> respects the privacy and will not collect any
              identifiable information using Google or any other 3rd party
              remarketing system.
            </p>
            <p>
              Opting out of Google´s use of cookies is always possible by
              visiting Google&#8217;s Ads Settings at{' '}
              <a
                href='http://google.com/settings/ads/onweb/optout?hl=en'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                here
              </a>
              . Alternatively, opting out can be done by visiting the{' '}
              <a
                href='http://optout.networkadvertising.org'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                Network Advertising Initiative opt out page
              </a>
              .
            </p>

            <li>
              <h2>Collection and processing of data with AdRoll</h2>
            </li>
            <p>
              <a
                href='https://www.adroll.com/de-DE/'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                AdRoll
              </a>{' '}
              is included in the program, {`user's`} have the option to opt-out
              by{' '}
              <a
                href='http://optout.networkadvertising.org/?c=1#!/'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                clicking here.
              </a>
            </p>

            {locale == 'en-US' ? (
              <div>
                <li>
                  <h2>Collection and processing of data with Wiredminds</h2>
                </li>
                <p>
                  Our website uses a counting pixel technology provided by{' '}
                  <a
                    href='http://www.wiredminds.de/en'
                    target='_blank'
                    rel='noreferrer'
                    className='link'
                  >
                    Wiredminds GmbH
                  </a>{' '}
                  to analyze visitor behavior. If necessary, data is collected,
                  processed and stored, from which user profiles are created
                  under a pseudonym. Wherever possible and reasonable, these
                  usage profiles are completely anonymized. Cookies can be used
                  for this purpose.
                </p>
                <p>
                  Cookies are small text files that are stored in the
                  visitor&#8217;s Internet browser and serve to recognize the
                  Internet browser. The collected data, which may also contain
                  personal data, will be transmitted to wiredminds or collected
                  directly by wiredminds. wiredminds may use information that is
                  left by visiting the websites to create anonymized usage
                  profiles.
                </p>
                <p>
                  The data obtained without explicit consent of the affected
                  person will not be used to personally identify the visitor of
                  this website and will not be merged with personal data of the
                  bearer of the pseudonym. Whenever IP addresses are recorded,
                  their immediate anonymization takes place by deleting the last
                  number block.
                </p>
                <p>
                  <a
                    href='http://wm2.wiredminds.de/track/cookie_mgr.php?mode=dont_track_ask&amp;websitesel=fd31cec47bac10d6&amp;lang=en'
                    target='_blank'
                    rel='noreferrer'
                    className='link'
                  >
                    Exclude from tracking
                  </a>
                </p>
              </div>
            ) : null}
            <li>
              <h2>Collection and processing of data with Hotjar</h2>
            </li>
            <p>
              We use{' '}
              <a
                href='https://www.hotjar.com/'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                Hotjar
              </a>{' '}
              in order to better understand our users needs and to optimize this
              service and experience. Hotjar is a technology service that helps
              us better understand our users experience (e.g. how much time they
              spend on which pages, which links they choose to click, what users
              do and don&#8217;s like, etc.) and this enables us to build and
              maintain our service with user feedback. Hotjar uses cookies and
              other technologies to collect data on our users behavior and their
              devices (in particular devices IP address (captured and stored
              only in anonymized form), device screen size, device type (unique
              device identifiers), browser information, geographic location
              (country only), preferred language used to display our website).
              Hotjar stores this information in a pseudonymized user profile.
              Neither Hotjar nor we will ever use this information to identify
              individual users or to match it with further data on an individual
              user.
            </p>
            <p>
              For further details, please see Hotjar&#8217;s privacy policy by
              clicking on{' '}
              <a
                href='https://www.hotjar.com/legal/policies/privacy'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                this link
              </a>
              . You can opt-out to the creation of a user profile, Hotjar’s
              storing of data about your usage of our site and Hotjar’s use of
              tracking cookies on other websites by following this{' '}
              <a
                href='https://www.hotjar.com/legal/compliance/opt-out'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                opt-out link
              </a>
              .
            </p>

            <li>
              <h2>Data Protection Officer (DPO)</h2>
            </li>
            <p>
              The <strong>GDPR</strong> (General Data Protection Regulation) is
              the new legislation on data protection within the European Union
              territory, applicable from 25.05.2018. In line with{' '}
              <strong>GDPR</strong>, <strong>GM</strong> has designated a Data
              Protection Officer (DPO) to oversee compliance with this policy.
              Inquiries on issues related to data protection policy can be
              addressed to{' '}
              <a href='mailto:dpo@gindumac.com' className='link'>
                dpo@gindumac.com
              </a>{' '}
              or by post to GINDUMAC GmbH, Trippstadter Straße 110, D-67663
              Kaiserslautern.
            </p>
            <p>
              You have the right to make a complaint at any time to a
              supervisory authority. The &quot;Die Bundesbeauftragte für den
              Datenschutz und die Informationsfreiheit&quot; (BfDI) is the lead
              data protection supervisory authority for <strong>GM</strong> as a
              data controller based in Germany.
            </p>

            <li>
              <h2>Consert and revocation</h2>
            </li>
            <p>
              Insofar as the user or customer has granted his consent for the
              use, processing and transmission of his personal data for
              marketing purposes (e.g. electronic newsletter or offer mailing,
              use of Google Analytics) he can revoke this at all times with
              effect for the future without complying with a certain form or
              deadline. In addition, the user or customer – insofar as{' '}
              <strong>GM</strong> uses his data within a framework as permitted
              by law for example for postal marketing measures - can also object
              to this use. In both cases the user or customer has to send the
              revocation to:
            </p>
            <p>
              <strong>
                GINDUMAC GmbH&nbsp; Trippstadter Straße 110&nbsp; D-67663
                Kaiserslautern&nbsp; Tel.:{' '}
                <a href='tel:+4963134373820'>+49 631 343738 20</a>&nbsp; E-mail:{' '}
                <a
                  onClick={gtagContactEvent}
                  href='mailto:contact@gindumac.com'
                  className='link'
                >
                  contact@gindumac.com
                </a>
              </strong>
            </p>
            <p>
              After receipt of the revocation <strong>GM</strong> will use the
              personal data of the user or customer exclusively for processing
              the respective order or the purchase order and refrain from
              sending further advertising means.
            </p>

            <li>
              <h2>Transmission of personal data to third parties</h2>
            </li>
            <p>
              In order to process the order or the purchase order it is
              necessary to also send personal data of the user or customer to
              third parties (e.g. to suppliers, freight forwarders, commercial
              credit insurers and, if applicable, also to the respective
              factor). The data forwarded to third parties will be exclusively
              used hereby in order to fulfil the obligations or tasks for which
              they are responsible or to secure the financing of the respective
              business. Transmissions to state institutions or authorities shall
              only be carried out within the framework of mandatory national
              regulations.
            </p>

            <li>
              <h2>Duration of the data storage</h2>
            </li>
            <p>
              The personal data of the user or customers will only be stored for
              as long as this is necessary for the provision of the services by{' '}
              <strong>GM</strong>. In an individual case a data storage beyond
              this can be necessary owing to statutory or legal obligations.
            </p>

            <li>
              <h2>Data security</h2>
            </li>
            <p>
              <strong>GM</strong> has set up technical and organisational safety
              precautions in order to protect the data of the user or customer,
              in particular against loss, manipulation or unauthorised access.{' '}
              <strong>GM</strong> shall regularly adjust its safety precautions
              to the continuous technical development.
            </p>

            <li>
              <h2>Information</h2>
            </li>
            <p>
              The user or customer has the right at all times to request free
              information about the data stored at <strong>GM</strong> relating
              to him. If the data should be stored incorrectly or unjustifiably{' '}
              <strong>GM</strong> will correct, block or delete it. The user or
              customer is obliged to report changes to his data to{' '}
              <strong>GM</strong>. The user or customer has to send requests for
              information, questions, complaints or suggestions relating to the
              topic of data protection by post to{' '}
              <strong>
                GINDUMAC GmbH, Trippstadter Straße 110, D-67663 Kaiserslautern
              </strong>{' '}
              or by e-mail to{' '}
              <a
                onClick={gtagContactEvent}
                href='mailto:contact@gindumac.com'
                className='link'
              >
                contact@gindumac.com
              </a>
              .
            </p>

            <li>
              <h2>Credit and identity check</h2>
            </li>
            <p>
              Credit risks exist within the scope of the financing possibilities
              offered by <strong>GM</strong>, which render it necessary that{' '}
              <strong>GM</strong> will reinsure itself with regard to the
              solvency of its customers and obtain credit rating information.{' '}
              <strong>GM</strong> will for this purpose send the customer’s
              data, if applicable still before conclusion of the contract, for
              the purpose of the credit check to various credit agencies of its
              choice, such as e.g.:
              <br />
              <br />- Creditsafe Deutschland GmbH
              <br /> Schreiberhauer Straße 30
              <br /> 10317 Berlin
              <br />{' '}
              <a
                href='http://www.creditsafede.com'
                target='_blank'
                rel='noreferrer'
                className='link'
              >
                http://www.creditsafede.com
              </a>
              <br />
              <br />- CEG Creditreform Boniversum GmbH
              <br /> (Germany)
              <br /> Hellerbergstraße 11
              <br /> D-41460 Neuss
              <br />{' '}
              <a
                href='http://meineauskunft.org'
                target='_blank'
                rel='noreferrer'
              >
                http://meineauskunft.org
              </a>
              <br />
              <br />- Schufa Holding AG
              <br /> Kormoranweg 5
              <br /> 65201 Wiesbaden
              <br />{' '}
              <a
                href='https://www.meineschufa.de'
                target='_blank'
                rel='noreferrer'
              >
                https://www.meineschufa.de
              </a>
              <br />
              <br />- Bürgel Wirtschaftsinformationen
              <br /> GmbH & Co.KG
              <br /> Gasstraße 18
              <br /> 22761 Hamburg
              <br />{' '}
              <a href='http://www.buergel.de' target='_blank' rel='noreferrer'>
                http://www.buergel.de
              </a>
              <br />
              <br />- Infoscore Consumer Data GmbH
              <br /> (Germany)
              <br /> Department of Data protection
              <br /> Rheinstraße 99
              <br /> 76532 Baden-Baden
              <br />{' '}
              <a href=' http://www.arvato-infoscore.de' target='_blank'>
                {' '}
                http://www.arvato-infoscore.de
              </a>
            </p>

            <p>
              and request these for information and creditworthiness information
              based on mathematical-statistical procedures (score value) insofar
              as this is necessary in order to safeguard justified interests of{' '}
              <strong>GM</strong> and the concerns of the future customer, which
              are worthy of protection, are not impaired. Information about
              conduct of the customer that is not as per contract (e.g. with
              credit card abuse) will, if applicable, also be sent. The credit
              agencies shall store the data sent to you in order to be able to
              provide the companies affiliated with them information for the
              assessment of the creditworthiness of the customer, shall only
              make these data available to their contractual partners, insofar
              as these credibly present a justified interest in the data
              transmission; the data will be exclusively used for this purpose.{' '}
            </p>
            <p>
              The customer can, as a rule, receive information himself from the
              aforementioned credit agencies about the data stored with regard
              to his person.
            </p>
            <p>
              <strong>GM</strong> shall, moreover, send the data of the customer
              before conclusion of the contract for the purpose of the identity
              check to the credit agency (agencies) selected by it, following
              which the credit agency (agencies) determine the degree of
              correspondence of the personal details stored in their company
              with the data collected by the customer from <strong>GM</strong>{' '}
              in terms of percentages. Based on the correspondence rates
              determined by the credit agencies <strong>GM</strong> can
              accordingly recognise whether a person is stored under the address
              provided by him in the data stocks of the respective credit agency
              (agencies) and is more than 18 years old.
            </p>
            <p>
              A further exchange of data or a transmission of deviating
              addresses as well as a storage of the customer’s data in the data
              stocks of the respective credit agency do not take place.{' '}
            </p>
            <p>
              It is solely stored for the purpose of proof of the fact of the
              check at the credit agency (agencies) involved. More detailed
              information is available under the aforementioned Internet
              addresses.
            </p>
          </ol>
        </>
      ) : (
        <>
          <h1>Datenschutzerklärung der GINDUMAC GmbH</h1>
          <span className='date'>Stand 25.05.2018</span>

          <p>
            Die GINDUMAC GmbH (nachfolgend „<strong>GM</strong>&quot; genannt)
            nimmt die Belange des Datenschutzes ernst und möchte sicherstellen,
            dass die Privatsphäre der Nutzer ihrer Webseiten sowie ihrer Kunden
            geschützt wird. Mit den nachfolgenden Hinweisen zur
            Datenverarbeitung soll der Nutzer bzw. Kunde über die Verwendung und
            den Umgang mit seinen Daten aufgeklärt werden.
          </p>
          <p>
            Die <strong>GM</strong> behält sich vor, den Inhalt der
            Datenschutzerklärung von Zeit zu Zeit anzupassen. Sie empfiehlt
            daher den Nutzern bzw. ihren Kunden, die nachfolgenden Hinweise zur
            Datenverarbeitung in regelmäßigen Abständen erneut durchzusehen.
          </p>
          <ol className='ml-4 list-decimal space-y-4'>
            <li>
              <h2>Personenbezogene Daten</h2>
            </li>
            <p>
              (1) <strong>GM</strong> erhebt, verarbeitet und nutzt die
              personenbezogenen Daten der Nutzer ihrer Webseite bzw. ihrer
              Kunden nur mit deren Einwilligung oder wenn eine Rechtsvorschrift
              dies erlaubt. <strong>GM</strong> wird nur solche
              personenbezogenen Daten erheben, verarbeiten und nutzen, die für
              die Durchführung und die Inanspruchnahme ihrer Leistungen
              erforderlich sind oder die der Kunde bzw. Nutzer der Webseite ihr
              freiwillig zur Verfügung stellt.
            </p>
            <p>
              (2) Personenbezogen sind alle Daten, die Angaben über persönliche
              oder sachliche Verhältnisse eines bestimmten oder bestimmbaren
              Nutzers bzw. Kunden enthalten. Dazu zählen beispielsweise der
              Name, die E-Mail-Adresse, die Wohnadresse, das Geschlecht, das
              Geburtsdatum, die Telefonnummer oder auch das Alter einer
              natürlichen Person.
            </p>

            <li>
              <h2>Zwecke der Erhebung personenbezogener Daten</h2>
            </li>
            <p>
              <strong>GM</strong> benötigt die personenbezogenen Daten des
              Kunden bzw. Nutzers der Website für folgende Zwecke:
              <br />
              <br />- Zur Abwicklung des erteilten Auftrags- bzw. der Bestellung
              (E-Mailadresse, Lieferadresse),
              <br />- Zur Beantwortung von Fragen (E-Mailadresse und
              Telefonnummer),
              <br />- bei Anmeldung zum Newsletter wird die E-Mail-Adresse für
              eigene Werbezwecke genutzt, bis sich der Nutzer bzw. Kunde vom
              Newsletter abmeldet. Die Abmeldung ist jederzeit möglich unter{' '}
              <a onClick={gtagContactEvent} href='mailto:contact@gindumac.com'>
                contact@gindumac.com
              </a>
              .
            </p>

            <li>
              <h2>Automatische Datenerfassung durch Cookies</h2>
            </li>
            <p>
              Ein Cookie ist eine kleine Textdatei, die im Zwischenspeicher des
              Browsers des Nutzers bzw. Kunden gespeichert wird und die eine
              Analyse der Nutzung der Website von <strong>GM</strong> durch den
              Nutzer bzw. Kunden ermöglicht. Folgende Daten werden bei Aufruf
              der Webseiten über Cookies vom <strong>GM</strong>-Computersystem
              automatisch erfasst:
            </p>
            <ul>
              <li>- Die Internetadresse (IP-Adresse) des Nutzers/Kunden,</li>
              <li>- Browsertyp und -version,</li>
              <li>
                - Webseite, von der der Nutzer/Kunde die Webseite der GINDUMAC
                GmbH besucht (Referrer URL)
              </li>
              <li>- verwendetes Betriebssystem,</li>
              <li>
                - Webseite von der aus der Nutzer/Kunde auf andere Webseiten
                weitergeleitet wird,
              </li>
              <li>- Datum und Uhrzeit des Zugriffs.</li>
            </ul>
            <p>
              Diese Daten werden getrennt von den weiteren Daten des Nutzers
              bzw. Kunden, die dieser <strong>GM</strong> freiwillig überlässt,
              gespeichert. Es erfolgt keine Verknüpfung dieser Daten mit den
              freiwillig abgegebenen Daten des Nutzers bzw. Kunden. Diese Daten
              werden lediglich zu statistischen Zwecken ausgewertet, um die{' '}
              <strong>GM</strong>-Webseiten und deren Angebote optimieren zu
              können. Die Daten werden nach ihrer Auswertung gelöscht.
            </p>
            <p>
              Sollte der Nutzer bzw. Kunde die Verwendung der Cookies nicht
              wünschen, kann er die Verwendung in seinem Browser sperren. Es ist
              in diesem Fall nicht auszuschließen, dass dadurch die
              Funktionalität der <strong>GM</strong>-Webseite beeinträchtigt
              wird.
            </p>
            <p>
              Weitere Details finden Sie in unseren{' '}
              <Link href={`/cookie-policy`}>Cookie-Richtlinien</Link>.
            </p>

            <li>
              <h2>
                Erhebung und Verarbeitung von Daten bei Einsatz von
                Google-Analytics
              </h2>
            </li>
            <p>
              Diese Webseite benutzt Google-Analytics, einen Webanalysedienst
              der Google Inc. (nachstehend „Google“ genannt). Google-Analytics
              verwendet sogenannte „Cookies“. Dies sind Textdateien, die auf dem
              Computer des Nutzers bzw. Kunden gespeichert werden und die
              Analyse der Benutzung der Webseite durch den Nutzer bzw. Kunden
              ermöglichen.
            </p>
            <p>
              Die durch den Cookie erzeugten Informationen über die Benutzung
              der Webseite werden anonymisiert, so dass sie nicht mehr einem
              Anschluss zugeordnet werden können. Diese anonymisierten Daten
              werden an einen Server von Google in den USA übertragen und dort
              gespeichert. Im Falle der Aktivierung der IP-Anonymisierung auf
              dieser Webseite wird die IPAdresse des Nutzers bzw. Kunden von
              Google jedoch innerhalb der Mitgliedstaaten der EU oder anderen
              Vertragsstaaten des Abkommens über den Europäischen
              Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die
              volle IP-Adresse an einen Server in die USA übertragen und dort
              gekürzt. Im Auftrag des Betreibers dieser Webseite wird Google
              diese Informationen benutzen, um die Nutzung der Webseite durch
              den Nutzer bzw. Kunden auszuwerten, um Reports über die
              Webseitenaktivitäten für die Webseitenbetreiber zusammenzustellen
              und um weitere mit der Webseitennutzung und der Internetnutzung
              verbundene Dienstleistungen zu erbringen.
            </p>
            <p>
              Google wird in keinem Fall die IP-Adresse des Nutzers bzw. Kunden
              mit anderen Daten von Google in Verbindung bringen. Der Nutzer
              bzw. Kunde kann die Installation der Cookies durch eine
              entsprechende Einstellung der Browser-Software verhindern.{' '}
              <strong>GM</strong> weißt den Nutzer bzw. Kunden darauf hin, dass
              in diesem Fall ggf. nicht mehr sämtliche Funktionen der besuchten
              Webseite vollumfänglich genutzt werden können.
            </p>
            <p>
              Der Nutzer bzw. Kunde kann darüber hinaus die Erfassung der durch
              das Cookie erzeugten und auf die Nutzung der Webseite bezogenen
              Daten, einschließlich der IP-Adresse, an Google sowie die
              Verarbeitung dieser Daten durch Google verhindern, indem dieser
              ein Browser Add zur Deaktivierung von Google Analytics
              herunterlädt und für seinen Browser installiert. Das
              Deaktivierungs-Add-On ist über{' '}
              <a
                href='http://tools.google.com/dlpage/gaoptout?hl=de'
                target='_blank'
                rel='noreferrer'
              >
                http://tools.google.com/dlpage/gaoptout?hl=de
              </a>
              &nbsp;abrufbar.
            </p>

            <li>
              <h2>Erhebung und Verarbeitung von Daten mit AdRoll</h2>
            </li>
            <p>
              <a
                href='https://www.adroll.com/de-DE/'
                target='_blank'
                rel='noreferrer'
              >
                AdRoll
              </a>{' '}
              ist im Programm enthalten, Benutzer haben die Möglichkeit, sich
              abzumelden, indem Sie{' '}
              <a
                href='http://optout.networkadvertising.org/?c=1#!/'
                target='_blank'
                rel='noreferrer'
              >
                hier klicken.
              </a>
            </p>

            {locale == 'de-DE' ? (
              <div>
                <li>
                  <h2>Analyse durch wiredminds</h2>
                </li>
                <p>
                  Unsere Webseite nutzt die Zählpixeltechnologie der{' '}
                  <a
                    href='http://www.wiredminds.de'
                    target='_blank'
                    rel='noreferrer'
                  >
                    Wiredminds GmbH
                  </a>{' '}
                  zur Analyse des Besucherverhaltens.
                </p>
                <p>
                  Dabei werden ggf. Daten erhoben, verarbeitet und gespeichert,
                  aus denen unter einem Pseudonym Nutzungsprofile erstellt
                  werden. Wo möglich und sinnvoll werden diese Nutzungsprofile
                  vollständig anonymisiert. Hierzu können Cookies zum Einsatz
                  kommen.
                </p>
                <p>
                  Cookies sind kleine Textdateien, die im Internet-Browser des
                  Besuchers gespeichert werden und zur Wiedererkennung des
                  Internet-Browsers dienen. Die erhobenen Daten, die auch
                  personenbezogene Daten beinhalten können, werden an wiredminds
                  übermittelt oder direkt von wiredminds erhoben. wiredminds
                  darf Informationen, die durch Besuche auf den Webseiten
                  hinterlassen werden, nutzen um anonymisierte Nutzungsprofile
                  zu erstellen. Die dabei gewonnenen Daten werden ohne die
                  gesondert erteilte Zustimmung des Betroffenen nicht benutzt,
                  um den Besucher dieser Webseite persönlich zu identifizieren
                  und sie werden nicht mit personenbezogenen Daten über den
                  Träger des Pseudonyms zusammengeführt. Soweit IP-Adressen
                  erfasst werden, erfolgt deren sofortige Anonymisierung durch
                  Löschen des letzten Nummernblocks.
                </p>
                <p>
                  <a
                    href='http://wm2.wiredminds.de/track/cookie_mgr.php?mode=dont_track_ask&amp;websitesel=fd31cec47bac10d6&amp;lang=de'
                    target='_blank'
                    rel='noreferrer'
                  >
                    Vom Tracking ausschließen.
                  </a>
                </p>
              </div>
            ) : null}

            <li>
              <h2>Erhebung und Verarbeitung von Daten mit Hotjar</h2>
            </li>
            <p>
              Wir nutzen{' '}
              <a
                href='https://www.hotjar.com/'
                target='_blank'
                rel='noreferrer'
              >
                Hotjar
              </a>
              , um die Bedürfnisse unserer Nutzer besser zu verstehen und das
              Angebot auf dieser Webseite zu optimieren. Mithilfe der
              Technologie von Hotjar bekommen wir eine besseres Verständnis von
              den Erfahrungen unserer Nutzer (z.B. wieviel Zeit Nutzer auf
              welchen Seiten verbringen, welche Links sie anklicken, was sie
              mögen und was nicht etc.) und das hilft uns, unser Angebot am
              Feedback unserer Nutzer auszurichten.
            </p>
            <p>
              Hotjar arbeitet mit Cookies und anderen Technologien, um
              Informationen über das Verhalten unserer Nutzer und über ihre
              Endgeräte zu sammeln (insbesondere IP Adresse des Geräts (wird nur
              in anonymisierter Form erfasst und gespeichert), Bildschirmgröße,
              Gerätetyp (Unique Device Identifiers), Informationen über den
              verwendeten Browser, Standort (nur Land), zum Anzeigen unserer
              Webseite bevorzugte Sprache).
            </p>
            <p>
              Hotjar speichert diese Informationen in einem pseudonymisierten
              Nutzerprofil. Die Informationen werden weder von Hotjar noch von
              uns zur Identifizierung einzelner Nutzer verwendet oder mit
              weiteren Daten über einzelne Nutzer zusammengeführt. Weitere
              Informationen finden Sie in Hotjars Datenschutzerklärung{' '}
              <a
                href='https://www.hotjar.com/legal/policies/privacy'
                target='_blank'
                rel='noreferrer'
              >
                hier
              </a>
              .
            </p>
            <p>
              Sie können der Speicherung eines Nutzerprofils und von
              Informationen über Ihren Besuch auf unserer Webseite durch Hotjar
              sowie dem Setzen von Hotjar Tracking Cookies auf anderen Webseiten
              widersprechen, wenn Sie diesen{' '}
              <a
                href='https://www.hotjar.com/legal/compliance/opt-out'
                target='_blank'
                rel='noreferrer'
              >
                Opt-Out-Link
              </a>{' '}
              anklicken.
            </p>

            <li>
              <h2>Datenschutzbeauftragten (DSB)</h2>
            </li>
            <p>
              Die Datenschutz-Grundverordnung (DSGVO, engl. GDPR) ist die neue
              Verordnung zum Datenschutz im Gebiet der Europäischen Union, die
              ab dem 25.05.2018 in Kraft tritt. In Übereinstimmung mit der DSGVO
              hat die <strong>GM</strong> einen Datenschutzbeauftragten (DSB)
              benannt, der die Einhaltung dieser Richtlinie überwacht. Anfragen
              zu datenschutzrechtlichen Fragen richten Sie bitte an{' '}
              <a href='mailto:dpo@gindumac.com'>dpo@gindumac.com</a> oder per
              Post an die GINDUMAC GmbH, Trippstadter Straße 110, D-67663
              Kaiserslautern.
            </p>
            <p>
              Sie haben jederzeit das Recht, bei einer Aufsichtsbehörde
              Beschwerde einzulegen. Die Bundesbeauftragte für den Datenschutz
              und die Informationsfreiheit (BfDI) ist die oberste
              Datenschutzaufsichtsbehörde für <strong>GM</strong> als
              Datenverantwortlicher mit Sitz in Deutschland.
            </p>

            <li>
              <h2>Einwilligung und Widerruf</h2>
            </li>
            <p>
              Soweit der Nutzer bzw. Kunde seine Einwilligung in die Nutzung,
              Verarbeitung und Übermittlung seiner personenbezogenen Daten zu
              Marketingzwecken (z.B. elektronische Newsletter- oder
              Angebotszusendungen, Nutzung von Google Analytics) erteilt hat,
              kann er diese jederzeit ohne Einhaltung einer bestimmten Form oder
              Frist mit Wirkung für die Zukunft widerrufen. Daneben kann der
              Nutzer bzw. Kunde -soweit <strong>GM</strong> dessen Daten in
              gesetzlich zulässigem Rahmen für beispielsweise postalische
              Marketingmaßnahmen nutzt- auch dieser Nutzung widersprechen. In
              beiden Fällen hat der Nutzer bzw. Kunde den Widerruf an:
              <br />
              <br />
              <strong>
                GINDUMAC GmbH&nbsp; Trippstadter Straße 110&nbsp; D-67663
                Kaiserslautern&nbsp; Tel.:{' '}
                <a href='tel:+4963134373820'>+49 631 343738 20</a>&nbsp; E-mail:{' '}
                <a
                  onClick={gtagContactEvent}
                  href='mailto:contact@gindumac.com'
                >
                  contact@gindumac.com
                </a>
              </strong>
            </p>
            <p>zu richten.</p>
            <p>
              Nach Erhalt des Widerrufs wird <strong>GM</strong> die
              personenbezogenen Daten des Nutzers bzw. Kunden ausschließlich zur
              Abwicklung des jeweiligen Auftrags bzw. der Bestellung verwenden
              und eine Versendung von weiteren Werbemitteln unterlassen.
            </p>

            <li>
              <h2>Übermittlung personenbezogener Daten an Dritte</h2>
            </li>
            <p>
              Für die Abwicklung des Auftrags bzw. der Bestellung ist es
              notwendig, auch personenbezogene Daten des Nutzers bzw. Kunden an
              Dritte zu übermitteln (z.B. an Lieferanten, Spediteure,
              Warenkreditversicherer und ggf. auch den jeweiligen Factor). Die
              an Dritte weitergegebenen Daten werden von diesen ausschließlich
              zur Erfüllung der ihnen obliegenden Verpflichtungen oder Aufgaben
              bzw. zur Sicherstellung der Finanzierung des jeweiligen Geschäfts
              verwendet. Übermittlungen an staatliche Einrichtungen oder
              Behörden erfolgen nur im Rahmen zwingender nationaler
              Vorschriften.
            </p>

            <li>
              <h2>Dauer der Datenspeicherung</h2>
            </li>
            <p>
              Die personenbezogenen Daten des Nutzers bzw. Kunden werden nur so
              lange aufbewahrt, wie dies für die Erbringung der Leistungen durch{' '}
              <strong>GM</strong> erforderlich ist. Im Einzelfall kann eine
              darüber hinaus dauernde Datenspeicherung aufgrund gesetzlicher
              oder rechtlicher Pflichten erforderlich sein.
            </p>

            <li>
              <h2>Datensicherheit</h2>
            </li>
            <p>
              <strong>GM</strong> hat technische und organisatorische
              Sicherheitsvorkehrungen eingerichtet, um die Daten des Nutzers
              bzw. Kunden zu schützen, und zwar insbesondere gegen Verlust,
              Manipulation oder unberechtigten Zugriff. <strong>GM</strong>{' '}
              passt ihre Sicherheitsvorkehrungen regelmäßig der fortlaufenden
              technischen Entwicklung an.
            </p>

            <li>
              <h2>Auskünfte</h2>
            </li>
            <p>
              Der Nutzer bzw. Kunde hat jederzeit das Recht, kostenfrei Auskunft
              über die von ihm bei <strong>GM</strong> gespeicherten Daten zu
              verlangen. Soweit die Daten unrichtig oder zu Unrecht gespeichert
              sein sollten, wird <strong>GM</strong> diese berichtigen, sperren
              oder löschen. Der Nutzer bzw. Kunde ist verpflichtet, Änderungen
              bei seinen Daten <strong>GM</strong> mitzuteilen.
            </p>
            <p>
              Auskunftswünsche, Fragen, Beschwerden oder Anregungen zum Thema
              Datenschutz hat der Nutzer bzw. Kunde per Post an die{' '}
              <strong>
                GINDUMAC GmbH, Trippstadter Straße 110, D-67663 Kaiserslautern
              </strong>{' '}
              oder per E-Mail an{' '}
              <a onClick={gtagContactEvent} href='mailto:contact@gindumac.com'>
                contact@gindumac.com
              </a>{' '}
              zu richten.
            </p>

            <li>
              <h2>Bonitäts- und Identitätsprüfung</h2>
            </li>
            <p>
              Im Rahmen der von <strong>GM</strong> angebotenen
              Finanzierungsmöglichkeiten bestehen Kreditrisiken, die es
              erforderlich machen, dass <strong>GM</strong> sich hinsichtlich
              der Zahlungsfähigkeit ihrer Kunden rückversichert und
              Bonitätsauskünfte einholt. <strong>GM</strong> wird hierzu die
              Daten des Kunden gegebenenfalls noch vor Vertragsschluss zum Zweck
              der Bonitätsprüfung an verschiedene Kreditauskunfteien ihrer Wahl,
              wie z.B.:
              <br />
              <br />- Creditsafe Deutschland GmbH
              <br /> Schreiberhauer Straße 30
              <br /> 10317 Berlin
              <br />{' '}
              <a
                href='http://www.creditsafede.com'
                target='_blank'
                rel='noreferrer'
              >
                http://www.creditsafede.com
              </a>
              <br />
              <br />- CEG Creditreform Boniversum GmbH
              <br /> (Germany)
              <br /> Hellerbergstraße 11
              <br /> D-41460 Neuss
              <br />{' '}
              <a
                href='http://meineauskunft.org'
                target='_blank'
                rel='noreferrer'
              >
                http://meineauskunft.org
              </a>
              <br />
              <br />- Schufa Holding AG
              <br /> Kormoranweg 5
              <br /> 65201 Wiesbaden
              <br />{' '}
              <a
                href='https://www.meineschufa.de'
                target='_blank'
                rel='noreferrer'
              >
                https://www.meineschufa.de
              </a>
              <br />
              <br />- Bürgel Wirtschaftsinformationen
              <br /> GmbH & Co.KG
              <br /> Gasstraße 18
              <br /> 22761 Hamburg
              <br />{' '}
              <a href='http://www.buergel.de' target='_blank' rel='noreferrer'>
                http://www.buergel.de
              </a>
              <br />
              <br />- Infoscore Consumer Data GmbH
              <br /> (Germany)
              <br /> Department of Data protection
              <br /> Rheinstraße 99
              <br /> 76532 Baden-Baden
              <br />{' '}
              <a href=' http://www.arvato-infoscore.de' target='_blank'>
                {' '}
                http://www.arvato-infoscore.de
              </a>
            </p>
            <p>
              übermitteln und diese um Auskünfte und Bonitätsinformationen auf
              Basis mathematischstatistischer Verfahren (Score-Wert) ersuchen,
              soweit dies zur Wahrung berechtigter Interessen von{' '}
              <strong>GM</strong> erforderlich ist und die schutzwürdigen
              Belange des zukünftigen Kunden nicht beeinträchtigt werden.
              Übermittelt werden ggf. auch Informationen über
              nichtvertragsgemäßes Verhalten des Kunden (z.B. bei
              Kreditkartenmissbrauch).
            </p>
            <p>
              Die Auskunfteien speichert die ihnen übermittelten Daten, um den
              ihnen angeschlossenen Unternehmen Informationen zur Beurteilung
              der Kreditwürdigkeit des Kunden geben zu können, und stellen ihren
              Vertragspartnern diese Daten nur zur Verfügung, soweit diese ein
              berechtigtes Interesse an der Datenübermittlung glaubhaft
              darlegen; die Daten werden ausschließlich zu diesem Zweck
              verwendet.
            </p>
            <p>
              Der Kunde kann bei den o.g. Auskunfteien in der Regel selbst
              Auskunft über die zu seiner Person gespeicherten Daten erhalten.
            </p>
            <p>
              <strong>GM</strong> übermittelt die Daten des Kunden vor
              Vertragsschluss zudem zum Zweck der Identitätsprüfung an die von
              ihr ausgewählte(n) Auskunftei(n), woraufhin die Auskunftei(en) den
              Grad der Übereinstimmung der bei ihr gespeicherten Personalien mit
              den vom Kunden bei <strong>GM</strong> erhobenen Daten in
              Prozentwerten ermitteln.
            </p>
            <p>
              <strong>GM</strong> kann danach anhand der von den Auskunfteien
              übermittelten Übereinstimmungsraten erkennen, ob eine Person unter
              der von ihr angegebenen Anschrift im Datenbestand der jeweiligen
              Auskunftei(en) gespeichert und über 18 Jahre alt ist. Ein weiterer
              Datenaustausch oder eine Übermittlung abweichender Anschriften
              sowie eine Speicherung der Dateien des Kunden im Datenbestand der
              jeweiligen Auskunftei finden nicht statt.
            </p>
            <p>
              Es wird allein zu Belegzwecken die Tatsache der Überprüfung bei
              der bzw. den eingeschalteten Auskunftei(en) gespeichert. Nähere
              Informationen sind unter den vorgenannten Internet-Adressen
              erhältlich.
            </p>
          </ol>
        </>
      )}
    </LegalLayout>
  );
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/privacy/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  